import { render, staticRenderFns } from "./BreakTextForm.vue?vue&type=template&id=6e4c1df2&scoped=true&"
import script from "./BreakTextForm.vue?vue&type=script&lang=js&"
export * from "./BreakTextForm.vue?vue&type=script&lang=js&"
import style0 from "./BreakTextForm.vue?vue&type=style&index=0&id=6e4c1df2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4c1df2",
  null
  
)

export default component.exports